import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/lib/useLenis";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import MentionsLegales from "@/pages/MentionsLegales";
import ScrollToTop from "@/components/site/ScrollToTop";

function App() {
  useLenis();
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/journal" element={<BlogList />} />
            <Route path="/journal/:slug" element={<BlogPost />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
